export default class LocationCharacters extends Phaser.Group {
  constructor(game) {
    super(game);

    this.daphne = this.createCharacter('daphne');
    this.fred = this.createCharacter('fred');
    this.scooby = this.createCharacter('scooby');
    this.shaggy = this.createCharacter('shaggy');
    this.velma = this.createCharacter('velma');

    this.add(this.fred);
    this.add(this.velma);
    this.add(this.shaggy);
    this.add(this.daphne);
    this.add(this.scooby);

    this.velma.x = 110;
    this.velma.y = 71;

    this.scooby.x = 188;
    this.scooby.y = 102;

    this.shaggy.x = 318;
    this.shaggy.y = 23;

    this.daphne.x = 408;
    this.daphne.y = 42;
  }

  createCharacter(characterid) {
    const character = this.game.make.sprite(0, 0, 'location_' + characterid);
    character.animations.add('play');
    character.animations.play('play', 24, true);
    return character;
  }
}



// WEBPACK FOOTER //
// ./js/app/location/LocationCharacters.js